// extracted by mini-css-extract-plugin
export default {"dragContainer":"Carousel_dragContainer__JXkTz","spinContainer":"Carousel_spinContainer__Iyyr4","spin":"Carousel_spin__z8Z0k"};